export class SwipePayment {

    refNo: string;
    amount: number = 0;
    fromLocationCode: number;
    paymentType: string;
    type: string;
    swipePaymentResponseCode: number;
}
